<template>
  <div>
    <p>{{ label }} {{type}} block <strong>{{details.name}}</strong> (<a :href="link">Link</a>)</p>
  </div>
</template>

<script>
export default {
  name: "EventBlock",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
    link() {
      if (this.details.class == "Arm") {
        return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/arm/${this.details.parent_id}/events`;
      } else {
        if (this.details.EnrollmentStep.level == 'Study') {
          return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/enrollment`;
        } else {
          return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/arm/${this.details.EnrollmentStep.arm_id}/enrollment`;
        }
      }
    },
    type() {
      return this.details.class == 'Arm' ? 'event':'enrollment';
    }
  }
}
</script>

<style scoped>

</style>